import React, { useState } from "react";
import { FloatingLabel, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoadingBtn from '../shared/LoadingBtn';
import Validator from "../../services/Validator";
import { useNavigate } from "react-router-dom";
import Api from "../../services/ApiService";
import { FaRegCopy } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";

const generatePassword = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789[#?!@$%^&*-]";

  return Array.from({ length: 15 }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join("");
};

const PasswordComponent = (props) => {

    const API = new Api();
    const VALIDATOR = new Validator();
    const navigate = useNavigate();
    const [pass1, setPass1] = useState(""); // First password
    const [pass2, setPass2] = useState(""); // Second password
    const [errors, setErrors] = useState();
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const passInfo ="Das Passwort muss mindestens 10 Zeichen lang sein und mindestens eine Ziffer und einen Buchstabe enthalten."; // Error message for passwords field 
    let customer = props.customer; 
    const [generatedPw, setGeneratedPw] = useState(generatePassword());
    const [inClipboard, setInClipboard] = useState(false);

    
    
    // Field Handlers
    const pass1Handler = (e) => {
        setPass1(e.target.value);
    }
    const pass2Handler = (e) => {
        setPass2(e.target.value);
    }


    const nextHandler = (e) => {
        e.preventDefault();
        const allErrors = {};
        setIsLoading(true);

        if (!VALIDATOR.PasswordValid(pass1)) allErrors.pass1 = "Das Passwort muss mindestens 10 Zeichen lang sein und mindestens eine Ziffer und einen Buchstabe enthalten.";
        if (!VALIDATOR.PasswordsEquals(pass1, pass2)) allErrors.pass2 = "Passwort muss zwei Mal gleich eingegeben werden."
        if (!VALIDATOR.isDictEmpty(allErrors)) {
            setErrors(allErrors);
            setValidated(false);
            setIsLoading(false);
        } else {
            customer.password = pass1;
            if (props.isMailVerify) {
                API.mail_verified(props.customer.email)
                .then(() => {
                        setIsLoading(false);
                        setValidated(true);
                        localStorage.setItem('customer', JSON.stringify(customer));
                        navigate("/registration/");
                    })
                    .catch(err => {
                        setIsLoading(false);
                        allErrors.server = "Fehler bei Server, versuchen Sie später noch einmal";
                        setErrors(allErrors);
                        setValidated(false);
                    });
            } else {
                setIsLoading(false);
                setValidated(true);
                localStorage.setItem('customer', JSON.stringify(customer));
                navigate("/registration/");
            }
        }
    }

    const takeGeratedPassword = () => {
        setPass1(generatedPw)
        setPass2(generatedPw)
    }

    const copyGeneratedPasswordToClipboard = async() => {
        try {
            await navigator.clipboard.writeText(generatedPw);
            setInClipboard(true);

            setTimeout(() => {
                setInClipboard(false);
            }, 2000);
        }
        catch (err) {}
    }

    return (
        <div>
            <Form validated={validated} onSubmit={e => nextHandler(e)}>
                <Form.Group className="mb-3">
                    <Form.Text as="legend">
                        {passInfo}
                    </Form.Text>
                    <FloatingLabel label="Passwort">
                        <Form.Control
                            isValid={VALIDATOR.PasswordValid(pass1)}
                            isInvalid={!!errors?.pass1}
                            type="password"
                            value={pass1}
                            onChange={(e) => pass1Handler(e)}
                            placeholder="Passwort" />
                    </FloatingLabel>
                    {errors?.pass1? <small className="text-danger">{errors.pass1}</small>:null}
                </Form.Group>
                <Form.Group className="mb-3">
                    <FloatingLabel label="Passwort wiederholen" className="mb-3">
                        <Form.Control
                            isValid={VALIDATOR.PasswordValid(pass1) && pass1 === pass2}
                            isInvalid={!!errors?.pass2}
                            type="password"
                            value={pass2}
                            onChange={(e) => pass2Handler(e)}
                            placeholder="Passwort" />
                    </FloatingLabel>
                    {errors?.pass2? <small className="text-danger">{errors.pass2}</small>:null}
                </Form.Group>
                <div className="d-flex flex-row gap-2 align-items-center">
                    <a onClick={e => {e.preventDefault(); takeGeratedPassword()}} href="passwort/vorschlagen" className="link-energo">Vorschlag übernehmen</a>
                    <span>({generatedPw})</span>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="t1">In Zwischenablage kopieren</Tooltip>}>
                        <a href="#"
                            onClick={e => {e.preventDefault(); copyGeneratedPasswordToClipboard()}} 
                        >
                            {inClipboard ?
                                <FaCheck className="text-energo" /> :
                                <FaRegCopy size={20} className="text-muted" />
                            }
                        </a>
                    </OverlayTrigger>
                </div>
                {errors?.server? <small className="text-danger">{errors.server}</small>:null}
                <div className="text-end mt-5">
                    <LoadingBtn
                        type="submit"
                        text="Weiter"
                        isLoading={isLoading}
                    />
                </div>
            </Form>
        </div>
    )
}

export default PasswordComponent;